<!-- App内打开View -->
<template>
  <div v-if="isShow()">
    <div class="open-app-view-1">
      <div class="open-app-view">
        <!-- <div class="top-tips">{{tips}}</div> -->
        <div class="top-tips">下载{{exhibitionName}}App，获取更多商机、资讯信息</div>
        <div class="btn-views">
          <div class="download-btn" @click="download">下载App</div>
          <div class="open-btn" @click="openApp">已有App立即打开</div>
        </div>
      </div>
      <van-overlay :show="show" @click="show = false">
        <div class="tip-pop-view">
          <img v-if="android" class="tip-pop" src="../assets/android_browser_tips.png" />
          <img v-else class="tip-pop" src="../assets/ios_browser_tips.png" />
        </div>
      </van-overlay>
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import path from '../config/path'
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  props: {
    openKey: {
      type: String,
      default: ''
    },
    tips:{
      type: String,
      default: '下载金融展App，获取更多商机、资讯信息'
    }
  },
  data () {
    // 这里存放数据
    return {
      show: false,
      android: true,
      exhibitionName: '金融展'
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    isShow() {
      const query = this.$route.query
      const themeList = ['jinrong', 'baoli','meeting']
      if (themeList.includes(query.theme)) {
        return true
      }
      if (themeList.includes(query.app)) {
        return true
      }
      return false
    },
    setName() {
      const theme = this.$route.query.theme
      if (theme === 'baoli') {
        this.exhibitionName = '保利'
      }
      if (theme === 'mianliao') {
        this.exhibitionName = '面料展'
      }
      if (theme === 'jinrong') {
        this.exhibitionName = '金融展'
      }
    },
    openApp() {
      if (this.isWeixin()) {
        this.show = true;
        return;
      }
      if (this.$route.query.theme == 'baoli' && this.$route.query.type == 'meeting') {
        //  会议
       let openUrl = 'iexhibitionbaoli://eastfair';
        openUrl +='&path=meetDetail'+'&params=' + JSON.stringify(this.$route.query);
        window.location.href = openUrl;
        return;
      }
      if (this.$route.query.theme == 'baoli' || this.$route.query.app == 'baoli') {
        //  保利
        let openUrl = 'iexhibitionbaoli://eastfair';
        openUrl += '&params=' + this.$route.query.params;
        window.location.href = openUrl;
        return;
      }
      if (this.$route.query.theme == 'mianliao' || this.$route.query.app == 'mianliao') {
        //  面料
        var openUrl = '';
        if (this.judgeClient() == 'iOS') {
          openUrl = path['scheme']['mianliao']['iOS'];
        }
        if (this.judgeClient() == 'Android') {
          openUrl = path['scheme']['mianliao']['Android'];
        }
        openUrl = openUrl + '&params=' + this.$route.query.params;
        window.location.href = openUrl;
        return;
      }
      if (this.$route.query.theme == 'jinrong' || this.$route.query.app == 'jinrong') {
        //  金融
        var openUrl = '';
        if (this.judgeClient() == 'iOS') {
          openUrl = path['scheme']['jinrong']['iOS'] + '?path=' + path['iOS'][this.openKey];
        }
        if (this.judgeClient() == 'Android') {
          openUrl = path['scheme']['jinrong']['Android'] + '?path=' + path['Android'][this.openKey];
        }
        openUrl = openUrl + '&params=' + this.$route.query.params;
        window.location.href = openUrl;
        return;
      }
    
    },
    /*判断客户端*/
    judgeClient() {
      let client = '';
      if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {  //判断iPhone|iPad|iPod|iOS
        client = 'iOS';
      } else if (/(Android)/i.test(navigator.userAgent)) {  //判断Android
        client = 'Android';
      } else {
        client = 'PC';
      }
      return client;
    },
    download() {
      if (this.isWeixin()) {
        this.show = true;
        return;
      }
      if (this.$route.query.theme == 'baoli' || this.$route.query.app == 'baoli') {
        //  保利
        window.open('http://1z1.hk/nIfEJv')
        return;
      }
      if (this.$route.query.theme == 'mianliao' || this.$route.query.app == 'mianliao') {
        //  面料
        return;
      }
      if (this.$route.query.theme == 'jinrong' || this.$route.query.app == 'jinrong') {
        //  金融
        // window.open('http://zhxt.eastfair.com/79818698966');
        window.open('http://zhxt.eastfair.com/79837537982');
        return;
      }
    },
    isWeixin () { //判断是否是微信
      var ua = navigator.userAgent.toLowerCase();
      return ua.match(/MicroMessenger/i) == "micromessenger";
    },
    checkUserAgent() {
      const client = this.judgeClient()
      if (client === 'Android') {
        this.android = true
      } else if (client === 'iOS') {
        this.android = false
      }
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {
    this.checkUserAgent()
    // 根据路由参数设置展会名
    this.setName()
  },
  beforeCreate () {}, // 生命周期 - 创建之前
  beforeMount () {}, // 生命周期 - 挂载之前
  beforeUpdate () {}, // 生命周期 - 更新之前
  updated () {}, // 生命周期 - 更新之后
  beforeDestroy () {}, // 生命周期 - 销毁之前
  destroyed () {}, // 生命周期 - 销毁完成
  activated () {} // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
.open-app-view {
  position: fixed;
  bottom: 0px;
  left: 0px;
  width: 100%;
  height: 101px;
  background-color: rgba(0, 0, 0, .6);
}
.download-btn {
  margin-right: 8px;
  padding: 0px 17px;
  display: inline-block;  
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  background: var(--bgcolor);
  border-radius: 13px;
  height: 26px;
  line-height: 26px;
  color: #FFFFFF;
}
.open-btn {
  padding: 0px 17px;
  display: inline-block;  
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  background: #FFFFFF;
  border-radius: 13px;
  height: 26px;
  line-height: 26px;
  color: #424242;
}
.top-tips {
  font-size: 15px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #FFFFFF;
  margin-top: 20px;
  text-align: center;
  margin-bottom: 15px;
}
.btn-views {
  text-align: center;
}
.open-app-view-1 {
  height: 101px;
}
.tip-pop-view {
  position: relative;
}
.tip-pop {
  position: absolute;
  width: 250px;
  right: 20px;
  top: 20px;
}
</style>
